import { useContext, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { TextFieldWithFixedText } from 'shared/ui/TextFieldWithFixedText/TextFieldWithFixedText'
import { DoubleOptInPageContext } from 'pages/settings/pages/doubleOptIn/context/doubleOptInContext'
import styles from './styles.module.scss'

export const DoubleOptInSettingAutoCloseAdditional = observer(() => {
  const store = useContext(DoubleOptInPageContext)
  const [value, setValue] = useState(store?.autoCloseDays.toString() ?? '')

  if (!store) return null

  const handleBlur = (correctedValue: string) => {
    store.handleNumberSwitcher('autoCloseDays', correctedValue)
  }

  return (
    <div className={styles.wrap}>
      <TextFieldWithFixedText
        fixedValue='days'
        value={value}
        defaultValue='1'
        setValue={setValue}
        blurCallback={handleBlur}
      />
    </div>
  )
})
